import { FormControl } from '@angular/forms';

import { AppointmentTypes } from '@lib/core/models/visit.interface';

export enum PlanningType {
  Appointment = 'appointment',
  Laboratory = 'laboratory',
  Drugs = 'drugs',
}

export interface PlanPrescriptionPayload {
  $type: PlanningType;
  userId: string;
  prescriptions: PrescriptionDetails[];
  partnerId: string;
  locationId: string;
  doctorId?: string;
  startTime: string;
  endTime: string;
  price?: number;
  orderNumber?: string;
  source: PrescriptionSource;
  eventPlace: AppointmentEventPlaceType;
}

export interface UpdatePrescriptionPlanningPayload {
  partnerId: string;
  doctorId?: string;
  locationId: string;
  startTime?: string;
  endTime?: string;
  price?: number;
  franchise?: number;
  eventPlace: AppointmentEventPlaceType;
}

export interface LaboratoryScheduleSearch {
  userId?: string;
  prescriptionIds?: string[];
  partnerId?: string;
  locationId?: string;
  dateFrom?: string;
  dateTo?: string;
  latitude?: number;
  longitude?: number;
  maxDistanceMeters?: number;
}

export interface LaboratoryWithScheduleResponse {
  partnerId: string;
  partnerName: string;
  partnerImageUrl: string;
  locationId: string;
  locationName: string;
  locationAddress: string;
  latitude: number;
  longitude: number;
  nearestSlot: TimeSlot;
  timeSlots: TimeSlot[];
  schedule: ScheduleItem[];
}

export interface ScheduleItem {
  startTime: Date;
  endTime: Date;
  dayOfWeek: 'Sunday' | 'Monday' | 'Tuesday' | 'Wednesday' | 'Thursday' | 'Friday' | 'Saturday' | string;
  displayDate: string;
  workingHours: WorkingHours[];
}

export interface WorkingHours {
  from: string;
  to: string;
  displayHours: string;
}

export interface TimeSlot {
  startTime: string;
  endTime: string;
  duration: string;
  durationMinutes: number;
  available: boolean;
}

export interface PrescriptionDetails {
  id: string;
  franchise?: number;
  name?: string;
}

export enum PrescriptionSource {
  Manual = 'Manual',
  Suggestions = 'Suggestions',
  Slots = 'Slots',
}

export enum AppointmentEventPlaceType {
  Hospital = 'Hospital',
  Home = 'Home',
  Telemedicine = 'Telemedicine',
}

export enum CreateAppointmentModalType {
  ManualCreation = 'ManualCreation',
  BindToExisting = 'BindToExisting',
  Cancel = 'Cancel',
}

export interface CreateAppointmentControls {
  appointmentType: FormControl<AppointmentTypes>;
  appointmentName: FormControl<string>;
  prescriptionIds: FormControl<string[]>;
  partnerId: FormControl<string>;
  partnerName: FormControl<string>;
  locationId: FormControl<string>;
  locationName: FormControl<string>;
  doctorId: FormControl<string | null>;
  doctorName: FormControl<string>;
  date: FormControl<Date>;
  startTime: FormControl<Date>;
  endTime: FormControl<Date>;
  eventPlace: FormControl<AppointmentEventPlaceType>;
  price: FormControl<number | null>;
}

export interface CreateLaboratoryOrderControls {
  orderName: FormControl<string>;
  prescriptionIds: FormControl<string[]>;
  partnerId: FormControl<string>;
  partnerName: FormControl<string>;
  locationId: FormControl<string>;
  locationName: FormControl<string>;
  date: FormControl<Date>;
  startTime: FormControl<Date>;
  endTime: FormControl<Date>;
  price: FormControl<number | null>;
  orderNumber: FormControl<string | null>;
}

export interface AppointmentSuggestionResponse {
  partnerId: string;
  locationId: string;
  doctorId: string;
  doctorName: string;
  locationName: string;
  description: string;
  startDate: string;
  endDate: string;
  relatedAppointmentsIds: string[];
}
